var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4017 2.08447C13.8126 2.26495 14.053 2.69714 13.9895 3.14148L13.1526 9.00006L18.347 9.00005C18.5854 9.00001 18.8275 8.99996 19.0256 9.01793C19.214 9.035 19.5722 9.0802 19.8841 9.33084C20.242 9.61844 20.4484 10.0541 20.4444 10.5132C20.4409 10.9133 20.249 11.2192 20.143 11.3758C20.0314 11.5405 19.878 11.7278 19.7271 11.9123L11.7735 21.6333C11.4893 21.9807 11.0084 22.0961 10.5975 21.9157C10.1865 21.7352 9.94614 21.303 10.0096 20.8586L10.8466 15.0001L5.65212 15.0001C5.41374 15.0001 5.1716 15.0002 4.97349 14.9822C4.78517 14.9651 4.42693 14.9199 4.11505 14.6693C3.75717 14.3817 3.55072 13.946 3.55475 13.4869C3.55825 13.0868 3.75013 12.7809 3.85616 12.6244C3.96771 12.4597 4.12107 12.2723 4.27206 12.0878C4.27959 12.0786 4.28712 12.0694 4.29464 12.0602L12.2256 2.36682C12.5098 2.01943 12.9907 1.90398 13.4017 2.08447Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltfilled);
export default __webpack_public_path__ + "static/media/bolt.filled.c23b1aff5c87ce877b2bc16b37f5ebd9.svg";
export { ForwardRef as ReactComponent };